
const defaultState = () => {
    return {
        env: process.env.NODE_ENV,
        baseApiUrl: process.env.VUE_APP_BASE_API_URL,
        stateKey: 1,
        isLoading: false,
        isLoadingUnity: false,
        baseImgPath: process.env.VUE_APP_IMAGES_BASE_PATH
    }
}

export default defaultState;

